/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserCreateOnAppDto } from '../../models/user-create-on-app-dto';
import { UserItem } from '../../models/user-item';

export interface UserControllerCreate$Params {
      body: UserCreateOnAppDto
}

export function userControllerCreate(http: HttpClient, rootUrl: string, params: UserControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
  const rb = new RequestBuilder(rootUrl, userControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserItem;
      }>;
    })
  );
}

userControllerCreate.PATH = '/user';
